var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.548,
    height: 28.549,
    viewBox: "0 0 28.548 28.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7730",
    transform: "translate(-0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7721",
    transform: "translate(0.016 7.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7720",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    d: "M14.29 137.255v-10.887c-.309.029-.614.077-.924.091H4.477a.892.892 0 0 0-.892.892v.892H.908a.892.892 0 0 0-.892.892v5.353a.892.892 0 0 0 .892.892h2.676v.892a.892.892 0 0 0 .892.892h.541l3.586 9.56a1.774 1.774 0 0 0 1.313 1.11 1.746 1.746 0 0 0 1.611-.491l2.143-2.125a1.78 1.78 0 0 0 .33-2.064l-2.994-5.99h2.369c.306.015.61.063.915.091z",
    fill: "currentColor",
    transform: "translate(-0.016 -126.368)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7723",
    transform: "translate(16.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    d: "M300.359.432a.631.631 0 0 0-.059-.084.882.882 0 0 0-.373-.285c-.005 0-.009-.009-.014-.011s-.034 0-.052 0a.887.887 0 0 0-.25-.05.829.829 0 0 0-.173.036.985.985 0 0 0-.1.02.886.886 0 0 0-.391.253c-.007.007-.018.009-.025.016a18.774 18.774 0 0 1-10.909 6.464v11.4a18.771 18.771 0 0 1 10.909 6.462c.007.009.02.012.029.023a.865.865 0 0 0 .221.171c.027.016.048.039.075.052a.918.918 0 0 0 .364.079.932.932 0 0 0 .3-.052c.005 0 .009-.009.014-.011a.868.868 0 0 0 .373-.285c.021-.029.037-.054.057-.084a.863.863 0 0 0 .146-.46V.892a.863.863 0 0 0-.142-.46z",
    fill: "currentColor",
    transform: "translate(-288.016)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.73f827ae.svg";
export { ForwardRef as ReactComponent };